// Constants
import { DEACTIVATION_STATUSES, POPUP_STEPS, REQUEST_STATUSES } from '../constants';
import {
  GET_INVITED_CHILD_INFO,
  SET_POPUP_LOADING,
  SET_POPUP_STATUS,
  SET_POPUP_STEP,
  UPDATE_REQUEST_STATUS,
} from './constants';

// Actions
import { getFamilyChildData } from '../api/getFamilyChildData';
import { deactivateFamily } from '../api/deactivateFamily';
import { getDeactivationStatus } from '../api/getDeactivationStatus';

const updateRequestStatus = (string) => ({
  type: UPDATE_REQUEST_STATUS,
  payload: string,
});

const getInvitedChildData = (object) => ({
  type: GET_INVITED_CHILD_INFO,
  payload: object,
});

const setPopupStep = (string) => ({
  type: SET_POPUP_STEP,
  payload: string,
});

const setPopupStatus = (bool) => ({
  type: SET_POPUP_STATUS,
  payload: bool,
});

const setPopupLoading = (bool) => ({
  type: SET_POPUP_LOADING,
  payload: bool,
});

const getFamilyChildInfo = () => async (dispatch) => {
  try {
    dispatch(updateRequestStatus(REQUEST_STATUSES.loading));

    const response = await getFamilyChildData();

    dispatch(getInvitedChildData(response.data));
    dispatch(updateRequestStatus(REQUEST_STATUSES.idle));
  } catch (error) {
    dispatch(updateRequestStatus(REQUEST_STATUSES.error));
  }
};

const polling = (requestId, timeout, count) => async (dispatch, getState) => {
  try {
    const performanceTimer = performance.now();
    const state = getState();
    const { familyChild: { isOpen } } = state;

    const response = await getDeactivationStatus(requestId);
    const { data: { result } } = response;

    if (!isOpen) {
      dispatch(setPopupLoading(false));
      return;
    }

    if (count >= timeout
      || result === DEACTIVATION_STATUSES.error
      || result === DEACTIVATION_STATUSES.rejected
      || result === null
    ) {
      dispatch(setPopupStep(POPUP_STEPS.error));
      dispatch(setPopupLoading(false));
      return;
    }

    if (result === DEACTIVATION_STATUSES.complete) {
      dispatch(setPopupStep(POPUP_STEPS.success));
      dispatch(setPopupLoading(false));
      return;
    }

    if (result === DEACTIVATION_STATUSES.inProgress || result === DEACTIVATION_STATUSES.requestSent) {
      const millisecond = performance.now() - performanceTimer;
      const seconds = (millisecond / 1000);

      dispatch(polling(requestId, timeout, (count + seconds)));
    }
  } catch (error) {
    dispatch(setPopupStep(POPUP_STEPS.error));
    dispatch(setPopupLoading(false));
  }
};

const delay = 30;
const pollingInitValue = 0;

const disconnectFamilyService = (ctn) => async (dispatch) => {
  try {
    dispatch(setPopupLoading(true));

    const response = await deactivateFamily(ctn);

    const { data: { isSucceeded, result } } = response;

    if (isSucceeded && result) {
      dispatch(polling(result, delay, pollingInitValue));
    } else {
      dispatch(setPopupStep(POPUP_STEPS.error));
      dispatch(setPopupLoading(false));
    }
  } catch (error) {
    dispatch(setPopupStep(POPUP_STEPS.error));
    dispatch(setPopupLoading(false));
  }
};

export { getFamilyChildInfo, setPopupStep, setPopupStatus, disconnectFamilyService };
